/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";


export class BonusBunniesSoundConfig implements ISoundConfig {

    public static instance: BonusBunniesSoundConfig = new BonusBunniesSoundConfig();
    AS_WIN: string = "asWin";
    AS_WIN_BIG: string = "asWinBig";

    MAIN_GAME_AMBIANCE: string = "background-music-main";
    BONUS_GAME_AMBIANCE: string = "background-music-bonus";

    REELS_SPINNING_START_ON_SPIN_START: string = "reelsSpinning";
    REELS_SPINNING_LAST_SPIN_BONUS: string = "reelsSpinningLastSpin";
    REELS_SPINNING_DEFAULT: string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4"];
    REELS_BASE_GAME_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4"];
    REELS_BONUS_GAME_BOUNCE: string[] = ["reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus",
        "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus",
        "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus",
        "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus",
        "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus", "reelLandingBonus"];

    WILD_LANDING: string = "wildLanding";
    WILD_EXPLODE: string = "wildExplode";
    WILD_POP: string = "wildPop";
    BONUS_LANDING: string = "bonusLanding";
    BONUS_LANDING_WIN: string = "bonusLandingWin";
    BUNNY_JUMP: string = "rabbitJump";
    ANTICIPATION: string = "anticipation";
    ANTICIPATION_FAIL: string = "anticipationFail";
    WIN_TINY: string = "winTiny";
    WIN_SMALL: string = "winSmall";
    WIN_MEDIUM: string = "winMedium";
    WIN_LARGE: string = "winLarge";
    COUNTUP: string = "countup";
    COUNTUP_ENDS: string = "countupEnds";
    SPIN_BUTTON_SOUNDS: string[] = ["spinButton1", "spinButton2", "spinButton3", "spinButton4", "spinButton5", "spinButton6", "spinButton7", "spinButton8", "spinButton9",
        "spinButton10", "spinButton11", "spinButton12"];
    BIG_WIN: string = "bigwin";
    BIG_WIN_LEVEL: string = "bigwinLevel";
    BIG_WIN_ENDS: string = "bigwinEnds";
    BIG_WIN_COUNTUP: string = "bigwinCountup";
    COIN_FOUNTAIN: string = "coinFountain";
    BONUS_ENDS_SMALL: string = "bonusEndsSmall";
    BONUS_ENDS_BIG: string = "bonusEndsBig";
    BONUS_COUNTUP_ENDS_SMALL: string = "bonusCountupEndsSmall";
    BONUS_COUNTUP_ENDS_BIG: string = "bonusCountupEndsBig";
    BONUS_CARROT_LANDING: string = "bonusCarrotLanding";
    BONUS_FERTILIZER_LANDING: string = "bonusFertilizerLanding";
    BONUS_HARVESTER_LANDING: string = "bonusHarvesterLanding";
    BONUS_SETTLER_LANDING: string = "bonusSettlerLanding";
    BONUS_FERTILIZER_KISS: string = "bonusFertilizerKiss";
    BONUS_MULTIPLIER_SWEEP: string = "bonusMultiplierSweep";
    BONUS_MULTIPLIER_UPGRADE2: string = "bonusMultiplierUpgrade2";
    BONUS_MULTIPLIER_UPGRADE3: string = "bonusMultiplierUpgrade3";
    BONUS_MULTIPLIER_UPGRADE4: string = "bonusMultiplierUpgrade4";
    BONUS_MULTIPLIER_UPGRADE5: string = "bonusMultiplierUpgrade5";
    BONUS_MULTIPLIER_UPGRADE6: string = "bonusMultiplierUpgrade6";
    BONUS_MULTIPLIER_UPGRADE_REEL_1: string = "bonusMultiplierUpgradeReel1";
    BONUS_MULTIPLIER_UPGRADE_REEL_2: string = "bonusMultiplierUpgradeReel2";
    BONUS_MULTIPLIER_UPGRADE_LOOP: string = "bonusMultiplierUpgradeLoop";
    BONUS_EXPAND_REELS: string = "bonusExpandReels";
    BONUS_MULTIPLIER_UPDATE: string = "bonusMultiplierUpdate";
    BONUS_KEY_LANDING: string = "bonusKeyLanding";
    BONUS_CHEST_SWEEP: string = "bonusChestSweep";
    BONUS_CHEST_OPEN: string = "bonusChestOpen";
    BONUS_CHEST_MULTIPLIER: string = "bonusChestMultiplier";
    BONUS_INTRO_CLICK: string = "click";
    BIG_WIN_INITIAL_WIN: string = "bigwinInitialWin";
    BONUS_INTRO: string = "bonusIntro";
    CONTINUE_BUTTON_CLICK: string = "continueButton";
    BONUS_ENDS_COIN_FOUNTAIN: string = "bonusEndsCoinFountain";
    BONUS_SEES_WILD: string = "bonusSeesWild";
    BUNNY_LAUGH: string = "rabbitLaugh";
    BONUS_FILL_METER: string = "bonusFillMeter";

    constructor() {
        if (BonusBunniesSoundConfig.instance) {
            throw new Error("BonusBunniesSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}